<template>
  <div>
    <div style="text-align: left;">
      <el-button no="1" type="primary" style="flex-grow: 1" :disabled="isEdit" @click="addDetailHandler">{{ $t('Warehouse.AddCargo') }}</el-button>
      <el-button no="2" type="danger" style="flex-grow: 1" :disabled="isEdit" @click="delDetailHandler">{{ $t('SeaExport.DeleteGoods') }}</el-button>
    </div>
    <cargo-ag-grid
      no="grid"
      :config-module="gridConfigModule"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      :auto-fit-content="false"
      style="height: 300px; margin-top: 10px;"
      @gridReady="params=>{gridApi=params.api}"
    />
    <el-form
      v-if="displaySummary"
      label-width="100px"
      label-position="left"
      style="margin-right:10px"
    >
      <div>
        <el-form-item class="auto-width">
          <div style="display: flex;text-align: left" class="title-row">
            <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('SeaExport.Quantity') }}</div>
            <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('SeaExport.Weight') }} {{ openImperial ? 'LB' : 'KGS' }}</div>
            <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:130px;text-align: right;">{{ $t('SeaExport.Cubage') }} {{ openImperial ? 'CFT' : 'CBM' }}</div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Actual')" class="auto-width">
          <el-input-number no="3" :value="warehouseIn.quantitySum || undefined" :disabled="true" controls-position="right" :min="0" :max="999999999" :precision="0" @input="val=>{warehouseIn.quantitySum=val}" />
          <el-input-number v-show="openImperial" no="4" :value="warehouseIn.weightSumImperial || undefined" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" @input="val=>{warehouseIn.weightSumImperial=val}" />
          <el-input-number v-show="openImperial" no="5" :value="warehouseIn.cubAgeSumImperial || undefined" :disabled="true" controls-position="right" :precision="3" :min="0" :max="999999999" @input="val=>{warehouseIn.cubAgeSumImperial=val}" />
          <el-input-number v-show="!openImperial" no="4" :value="warehouseIn.weightSum || undefined" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" @input="val=>{warehouseIn.weightSum=val}" />
          <el-input-number v-show="!openImperial" no="5" :value="warehouseIn.cubageSum || undefined" :disabled="true" controls-position="right" :precision="3" :min="0" :max="999999999" @input="val=>{warehouseIn.cubageSum=val}" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Consignation')" class="auto-width">
          <el-input-number no="6" :value="job.quantityContract || undefined" :disabled="true" controls-position="right" :min="0" :max="999999999" :precision="0" @input="val=>{job.quantityContract=val}" />
          <el-input-number v-show="openImperial" no="7" :value="job.weightContractImperial || undefined" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" @input="val=>{job.weightContractImperial=val}" />
          <el-input-number v-show="openImperial" no="8" :value="job.cubAgeContractImperial || undefined" :disabled="true" controls-position="right" :precision="3" :min="0" :max="999999999" @input="val=>{job.cubAgeContractImperial=val}" />
          <el-input-number v-show="!openImperial" no="7" :value="job.weightContract || undefined" :disabled="true" controls-position="right" :precision="2" :min="0" :max="999999999" @input="val=>{job.weightContract=val}" />
          <el-input-number v-show="!openImperial" no="8" :value="job.cubageContract || undefined" :disabled="true" controls-position="right" :precision="3" :min="0" :max="999999999" @input="val=>{job.cubageContract=val}" />
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as NumberUtils from '@/utils/NumberUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import { WarehouseIn } from '@/class/model/booking/WarehouseIn'
import { WarehouseInDetail } from '@/class/model/booking/WarehouseInDetail'
import { SizeUtils } from '@/class/cargo/model/utils/SizeUtils'
import { delWarehouseInDetail } from '@/api/booking/warehouseInDetail'
import lodash from 'lodash'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import CargoAgGridColumnEditGroup from '@/components/Cargo/Common/CargoAgGridColumnEditGroup'
import $store from '@/store'

export default {
  name: 'WarehouseDetailGrid',
  components: {

  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    job: {
      type: Object,
      required: true
    },
    warehouseIn: {
      type: Object,
      required: true
    },
    openImperial: {
      type: Boolean,
      required: false
    },
    displaySummary: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        onCellFocused: event => {
          this.selectedRowIndex = event.rowIndex
        },
        context: {
          componentParent: this
        },
        suppressRowClickSelection: false,
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridCommonInputEditor,
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridColumnEditGroup
        }
      },
      gridParams: {},
      gridApi: null,
      selectedRowIndex: -1,
      rowData: []
    }
  },
  computed: {
    isEdit() {
      return this.action !== 'look'
    },
    selectedRow() {
      return this.rowData[this.selectedRowIndex]
    },
    isZh() {
      return $store.getters.language === 'zh'
    },
    gridConfigModule() {
      return !this.openImperial ? '1900000' : '1900002'
    },
    columnDefs() {
      const list = [
        {
          headerName: this.$t('SeaExport.PackageType'),
          field: 'packing',
          colId: 'packing',
          suppressMenu: true,
          width: 150,
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagName: this.isZh ? 'chineseName' : 'name',
              selectType: TYPE_NAMES.basic_data_Packing,
              callbackParams: { key: 'code' },
              callbackMethodType: 'value',
              filterable: true
            }
          },
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'code', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ItemsNBR'),
          field: 'quantity',
          colId: 'quantity',
          suppressMenu: true,
          width: 120,
          // 是否开启编辑
          editable: false,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 0,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          }
        }
      ]
      if (this.openImperial) {
        list.push({
          headerName: this.$t('CargoMsg.Cargo_measurements2'),
          field: 'dimensionImperial',
          colId: 'dimensionImperial',
          minWidth: 200,
          editable: true,
          suppressKeyboardEvent: this.suppressKeyboardEvent,
          cellEditor: 'CargoAgGridColumnEditGroup',
          cellEditorParams: {
            valueChanged: this.calculationDimensionImperial
          },
          onCellValueChanged: this.calculationDimensionImperial
        },
        {
          headerName: this.$t('SeaExport.Weight2') + 'LB',
          field: 'weightImperial',
          colId: 'weightImperial',
          suppressMenu: true,
          width: 120,
          // 是否开启编辑
          editable: true,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          },
          onCellValueChanged: (params) => {
            this.weightImperialChange(params)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Cubage') + 'CFT',
          field: 'cubAgeImperial',
          colId: 'cubAgeImperial',
          suppressMenu: true,
          width: 150,
          // 是否开启编辑
          editable: true,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 3)).format('0,0.000') || 0.000
          },
          onCellValueChanged: (params) => {
            this.cubAgeImperialChange(params)
          }
        })
      } else {
        list.push({
          headerName: this.$t('CargoMsg.Cargo_measurements'),
          field: 'dimension',
          colId: 'dimension',
          minWidth: 200,
          editable: true,
          suppressKeyboardEvent: this.suppressKeyboardEvent,
          cellEditor: 'CargoAgGridColumnEditGroup',
          cellEditorParams: {
            valueChanged: this.calculationDimension
          },
          onCellValueChanged: this.calculationDimension
        },
        {
          headerName: this.$t('SeaExport.Weight2') + 'KGS',
          field: 'weight',
          colId: 'weight',
          suppressMenu: true,
          width: 120,
          // 是否开启编辑
          editable: true,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
          },
          onCellValueChanged: (params) => {
            this.weightChange(params)
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage2'),
          field: 'cubage',
          colId: 'cubage',
          suppressMenu: true,
          width: 150,
          // 是否开启编辑
          editable: true,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return this.$numeral(NumberUtils.roundHalfUp(params.value, 3)).format('0,0.000') || 0.000
          },
          onCellValueChanged: (params) => {
            this.cubageChange(params)
          }
        })
      }
      list.push({
        headerName: this.$t('CargoMsg.Cargo_Remarks'),
        field: 'remarks',
        colId: 'remarks',
        suppressMenu: true,
        width: 150,
        // 是否开启编辑
        editable: true,
        // 单元格绑定编辑组件
        cellEditor: 'CargoAgGridCommonInputEditor',
        // 编辑组件入参
        cellEditorParams: {
          isNumber: false
        }
      })
      return list
    }
  },
  watch: {
  },
  async created() {
  },
  methods: {
    // 填充表单
    async fillView() {
      this.warehouseIn.warehouseInDetail = ''
      const warehouseInDetail = await new WarehouseIn(this.warehouseIn).getWarehouseInDetail()
      this.rowData = []
      if (warehouseInDetail && warehouseInDetail.length > 0) {
        for (const detail of warehouseInDetail) {
          if (this.openImperial) {
            if (detail.dimensionImperial) { // 拆分长宽高件数
              const array = detail.dimensionImperial.split('*')
              detail.sizeLength = array[0]
              detail.sizeWidth = array[1]
              detail.sizeHeight = array[2]
              detail.sizeQuantity = array[3]
            }
          } else {
            if (detail.dimension) { // 拆分长宽高件数
              const array = detail.dimension.split('*')
              detail.sizeLength = array[0]
              detail.sizeWidth = array[1]
              detail.sizeHeight = array[2]
              detail.sizeQuantity = array[3]
            }
          }
        }
        this.rowData = warehouseInDetail
      }
    },
    // 加入货物
    addDetailHandler() {
      const detail = new WarehouseInDetail().fillDefaultValue().getData()
      detail.warehouseInUuid = this.warehouseIn.uuid
      detail.dimension = '0*0*0*0'
      detail.sizeLength = 0
      detail.sizeWidth = 0
      detail.sizeHeight = 0
      detail.sizeQuantity = 0
      detail.quantity = 0
      detail.dimensionImperial = '0*0*0*0'
      detail.weightImperial = 0
      detail.cubAgeImperial = 0
      this.rowData.push(detail)
      this.calcuSum()
    },
    // 删除货物
    delDetailHandler() {
      if (this.selectedRow) {
        let index = -1
        const uuid = this.selectedRow.uuid
        for (let i = 0; i < this.rowData.length; i++) {
          if (lodash.isEqual(this.rowData[i], this.selectedRow)) {
            index = i
            break
          }
        }
        if (index > -1) {
          this.rowData.splice(index, 1)
          if (uuid) { // 如果已经存在，调用后台接口进行物理删除
            delWarehouseInDetail(uuid).then(res => {
              this.$message.warning('删除成功！')
            })
          }
        }
      } else {
        this.$message.warning(this.$t('SeaExport.SelectARecord'))
        return
      }
    },
    // 计算
    calcuSum() {
      let quantity = 0
      let weight = 0
      let cubage = 0
      let weightImperial = 0
      let cubAgeImperial = 0
      for (const detail of this.rowData) {
        quantity += detail.quantity
        weight += Number(detail.weight)
        cubage += Number(detail.cubage)
        weightImperial += Number(detail.weightImperial)
        cubAgeImperial += Number(detail.cubAgeImperial)
      }
      this.warehouseIn.quantitySum = quantity
      this.warehouseIn.weightSum = weight
      this.warehouseIn.cubageSum = cubage
      this.warehouseIn.weightSumImperial = weightImperial
      this.warehouseIn.cubAgeSumImperial = cubAgeImperial
    },
    // 重量改变
    async weightImperialChange(params) {
      const { node, newValue, oldValue } = params
      if (newValue && newValue === oldValue) {
        return
      }
      node.setDataValue('weightImperial', params.data.weightImperial)
      params.data.weight = await JobUtils.calculateWeight(params.data.weightImperial)
      this.calcuSum()
    },
    async weightChange(params) {
      const { node, newValue, oldValue } = params
      if (newValue && newValue === oldValue) {
        return
      }
      node.setDataValue('weight', params.data.weight)
      params.data.weightImperial = await JobUtils.calculateWeight(params.data.weight, true)
      this.calcuSum()
    },
    // 体积改变
    async cubAgeImperialChange(params) {
      const { node, newValue, oldValue } = params
      if (newValue && newValue === oldValue) {
        return
      }
      node.setDataValue('cubAgeImperial', params.data.cubAgeImperial)
      params.data.cubage = await JobUtils.calculateCubAge(params.data.cubAgeImperial)
      this.calcuSum()
    },
    async cubageChange(params) {
      const { node, newValue, oldValue } = params
      if (newValue && newValue === oldValue) {
        return
      }
      node.setDataValue('cubage', params.data.cubage)
      params.data.cubAgeImperial = await JobUtils.calculateCubAge(params.data.cubage, true)
      this.calcuSum()
    },
    // 验证内容
    validate() {
      if (this.warehouseIn.warehouseInDetail) {
        for (const detail of this.warehouseIn.warehouseInDetail) {
          if (!SizeUtils.validateSize(detail.dimension)) {
            this.$message.warning(this.$t('AirExport.PleaseFormatOfTheLengthwidthheightquantity'))
            return false
          } else if (detail.quantity === 0) {
            this.$message.warning(this.$t('Message.PleaseTheNumberOfPieces'))
            return false
          }
        }
      }
      return true
    },
    async calculationDimensionImperial(params) {
      const { newValue, oldValue } = params
      if (newValue && newValue === oldValue) {
        return
      }
      const data = params.data
      data.quantity = data.sizeQuantity || 0
      const sizeLength = (data.sizeLength || 0)
      const sizeWidth = (data.sizeWidth || 0)
      const sizeHeight = (data.sizeHeight || 0)
      const sizeQuantity = (data.sizeQuantity || 0)
      data.dimensionImperial = sizeLength + '*' + sizeWidth + '*' + sizeHeight + '*' + sizeQuantity
      data.cubAgeImperial = (sizeLength / 100) * (sizeWidth / 100) * (sizeHeight / 100) * sizeQuantity
      const value = JobUtils.calcCubageQuantity(data.dimensionImperial)
      if (value) {
        data.cubAgeImperial = NumberUtils.roundHalfUp(value[0], 3)
      }
      const node = this.gridApi.rowModel.rowsToDisplay.find(p => p.data === data)
      if (node) {
        node.setDataValue('cubAgeImperial', data.cubAgeImperial)
      }
      // 计算公制
      data.dimension = await JobUtils.calculateDimension(sizeLength, sizeWidth, sizeHeight, sizeQuantity)
      data.cubage = await JobUtils.calculateCubAge(data.cubAgeImperial)
      this.gridOptions.api.refreshCells({ force: true })
    },
    async calculationDimension(params) {
      const { newValue, oldValue } = params
      if (newValue && newValue === oldValue) {
        return
      }
      const data = params.data
      data.quantity = data.sizeQuantity || 0
      const sizeLength = (data.sizeLength || 0)
      const sizeWidth = (data.sizeWidth || 0)
      const sizeHeight = (data.sizeHeight || 0)
      const sizeQuantity = (data.sizeQuantity || 0)
      data.dimension = sizeLength + '*' + sizeWidth + '*' + sizeHeight + '*' + sizeQuantity
      data.cubage = (sizeLength / 100) * (sizeWidth / 100) * (sizeHeight / 100) * sizeQuantity
      const value = JobUtils.calcCubageQuantity(data.dimension)
      if (value) {
        data.cubage = NumberUtils.roundHalfUp(value[0], 3)
      }
      const node = this.gridApi.rowModel.rowsToDisplay.find(p => p.data === data)
      if (node) {
        node.setDataValue('cubage', data.cubage)
      }
      // 计算英制
      data.dimensionImperial = await JobUtils.calculateDimension(sizeLength, sizeWidth, sizeHeight, sizeQuantity, true)
      data.cubAgeImperial = await JobUtils.calculateCubAge(data.cubage)
      this.gridOptions.api.refreshCells({ force: true })
    },
    suppressKeyboardEvent(param) {
      const currInput = param.event.target.attributes['data-index']
      if (currInput) {
        if (param.event.keyCode === 9 && currInput.value === 'sizeQuantity') {
          return false
        }
      }
      return true
    }
  }
}
</script>

<style lang="scss">
.second-row-card {
  .title-row {
    div {
      margin-right: 305px;
    }
  }
  .content-row {
    .el-input-number {
      margin-right: 145px;
      width: 210px!important;
    }
  }
}
</style>
